const sections = document.getElementsByClassName('m-topics');

class TopicSection {
  constructor(container) {
    this.container = container;

    this.build();
    this.addEventListeners();
  }

  build() {
    const { container } = this;

    this.buttons = container.getElementsByClassName('m-topics__button');
    // this.galleries = container.getElementsByClassName('m-topics__images-wrap');
  }

  addEventListeners() {
    const { buttons } = this;

    [].map.call(buttons, button => button.addEventListener('mouseenter', this.handleHover.bind(this)));
  }

  handleHover({ target }) {
    const el = document.getElementById(target.dataset.id);
    const currentEl = this.container.querySelector('.coloured');

    if (currentEl) currentEl.classList.remove('coloured');
    el.classList.add('coloured');
  }
}

function initTopicSections() {
  [].map.call(sections, section => new TopicSection(section));
}

if (sections.length) initTopicSections();
